<template>
  <div>
    <div class="sendrecord-select">
      <crumb-tit :roots="roots">
        <span slot="breadTit">推送记录</span>
      </crumb-tit>
      <div
        v-if="!listDataLoading"
        class="send-record-drop"
      >
        <a-dropdown>
          <a
            class="ant-dropdown-link"
            @click="e => e.preventDefault()"
          >
            {{ webhookName }}
            <!-- {{ listData.length> 0 ? listData.find(item => item.hookid === hookid * 1)['name']: '' }} -->
            <i class="iconfont iconicon-test15" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item
              v-for="item2 in listData"
              :key="item2.hookid"
              @click="getRecordList(item2)"
            >
              {{ item2.name }}
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <div class="webhook-table-list">
      <a-table
        :columns="sendListColumns"
        :data-source="sendRecordList"
        :pagination="false"
        :loading="recordListDataLoading"
        :custom-header-row="expandAllHandler"
        @change="handleChange"
      >
        <div
          slot="uptime"
          slot-scope="text"
        >
          {{ text> 0 ? $moment(text * 1000).format('YYYY-MM-DD HH:mm:ss') : '--' }}
        </div>
        <div
          slot="status"
          slot-scope="text, record"
        >
          <a-popover
            placement="bottomLeft"
            overlay-class-name="send-error-popover"
          >
            <template v-if=" text * 1 === 1 ">
              <div slot="content">
                <p> 已推送成功</p>
                <p>返回信息： {{ record.responsebody }}</p>
              </div>
            </template>
            <template v-else>
              <div slot="content">
                <p> 错误码：{{ record.responsecode }}</p>
                <p>错误原因： {{ record.responsebody }}</p>
              </div>
            </template>
            <span :class="{'send-error': (text * 1 === 0)}">
              {{ statusType[text * 1] }}
            </span>
          </a-popover>
        </div>
        <div
          slot="event_name"
          slot-scope="text, record"
          class="webhook-item-address"
        >
          {{ text }}
          <a-tag
            v-if="record.type === 2 || (record.type === 3)"
            class="test-event-tit"
          >
            {{ '测试' }}
          </a-tag>
        </div>
        <div
          slot="inquiry_code"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="toInquryInfo(record)"
          >
            {{ text }}
          </a>
        </div>
        <em
          slot="filterIcon"
          class="th-filter-icon anticon anticon-filter ant-table-filter-icon ant-dropdown-trigger"
        >
          <i class="iconfont iconicon-test19" />
        </em>
        <div
          slot="filterDropdown"
          slot-scope="{}"
          class="table-custom-filter-dropdown"
        >
          <div class="drop-down-box">
            <a
              href="javascript:;"
              :class="{'filter-active': filtersparams.status === 2}"
              @click="getList(2)"
            >{{ $t('message["904"]') }}</a>
            <a
              href="javascript:;"
              :class="{'filter-active': filtersparams.status === 1}"
              @click="getList(1)"
            >{{ $t('message["107"]') }}</a>
            <a
              href="javascript:;"
              :class="{'filter-active': filtersparams.status === 0}"
              @click="getList(0)"
            >失败</a>
          </div>
        </div>
        <div
          slot="operate"
          slot-scope="text,record"
        >
          <a
            href="javascript:;"
            @click="viewRecordInfo(record)"
          >查看推送数据</a>
          <a
            v-if="!record.status && (record.type !== 2) && (record.type !== 3)"
            href="javascript:;"
            class="send-btn"
            @click="sendRecordItem(record)"
          >再次推送</a>
        </div>
      </a-table>
      <pagination
        v-if="sendRecordList.length && sendListColumns.length"
        ref="pagination"
        :pagination="pagination"
        @change="handlePage"
      />
      <send-record-tip
        ref="delItemDialog"
        type="sendItem"
        @operateItem="operateItem"
      />
      <send-record-info
        ref="sendRcordInfo"
        :datas="recordInfo"
        :item="item"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import SendRecordTip from '@/components/pc/config/webhook/WebTipDialog'
import CrumbTit from '@/components/pc/config/CrumbTit'
import Pagination from '@/components/pc/Pagination'
import SendRecordInfo from '@/components/pc/config/webhook/SendRecordInfo'
export default {
  components: {
    SendRecordTip,
    CrumbTit,
    Pagination,
    SendRecordInfo
  },
  data () {
    return {
      recordInfo: {},
      sendAgainData: {},
      item: {},
      filtersparams: {}
    }
  },
  computed: {
    ...mapState('config/webhook', ['sendListColumns', 'listDataLoading', 'recordListDataLoading', 'listData', 'statusType', 'pagination']),
    ...mapGetters('config/webhook', ['sendRecordList']),
    roots () {
      return {
        to: 'configWebhookList',
        title: this.$t('message["282"]')
      }
    },
    hookid () {
      return this.$route.params.hookid
    },
    pid () {
      return this.$store.state.pid
    },
    webhookName () {
      let webhookN = '测试'
      const { listData = [], hookid = 0 } = this
      const item = listData.length > 0 ? listData.find(item => item.hookid === hookid * 1) : {}
      if (hookid * 1 === 0) {
        webhookN = '测试'
      } else {
        webhookN = item.name
      }
      return webhookN
    },
    comProjectName () {
      const { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      return `- ${projectname} - ${comname}`
    }
  },
  inject: ['reload'],
  async mounted () {
    await this.getWebhookList()
    await this.getWebhookRecordList({ hookid: this.hookid })
    this.pagination.currentPage = 1
    this.pagination.pageSize = 10
    this.$router.push({ name: 'configSendRecord', params: { hookid: this.hookid }, query: {} })
    const { recordListDataLoading, comProjectName } = this
    if (!recordListDataLoading) {
      document.title = '推送记录 ' + comProjectName
    }
  },
  methods: {
    ...mapActions('config/webhook', ['getWebhookRecordList', 'getWebhookList', 'getWebhookRecordDetail', 'sendRecordAgain']),
    async operateItem () {
      const chain = await this.sendRecordAgain(
        {
          recordid: this.sendAgainData.recordid,
          hookid: this.hookid
        }
      )
      chain.onSuccess(raw => {
        this.$refs.delItemDialog.changeLimitDialog(false)
        this.reload()
      })
        .fetch()
    },
    sendRecordItem (item) {
      this.sendAgainData = item
      this.$refs.delItemDialog.changeLimitDialog(true)
    },
    async getRecordList (item) {
      this.$router.push({
        name: 'configSendRecord',
        params: { hookid: item.hookid }
        // query: this.$route.query
      })
      this.pagination.currentPage = 1
      this.pagination.pageSize = 10
      await this.getWebhookRecordList({ hookid: item.hookid })
      this.filtersparams = {}
    },
    async handleChange (pagination, filters, sorter) {
      let sorttype = 0
      if (sorter.order === 'ascend') {
        sorttype = 1
      } else if (sorter.order === 'descend') {
        sorttype = 2
      } else {
        sorttype = 0
      }
      await this.getWebhookRecordList(
        { ...this.$route.query,
          hookid: this.hookid,
          sorttype
        }
      )
      this.pagination.currentPage = 1
      this.$router.push({
        name: 'configSendRecord',
        params: { hookid: this.hookid },
        query: { ...this.$route.query, sorttype }
      })
    },
    async getList (val) {
      // this.$router.push({ name: 'configSendRecord', params: { hookid: this.hookid } })
      document.querySelector('.anticon-filter').click()
      this.filtersparams = { status: val }
      this.$router.push({
        name: 'configSendRecord',
        params: { hookid: this.hookid },
        query: { ...this.$route.query, status: val, page: 1 }
      })
      await this.getWebhookRecordList({ ...this.$route.query, hookid: this.hookid, status: val, page: 1 })
      this.pagination.currentPage = 1
      // this.pagination.pageSize = 10
      // this.reload()
    },
    async handlePage (pagination) {
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize
        }
      })
      await this.getWebhookRecordList({ ...this.$route.query, hookid: this.hookid })
    },
    async viewRecordInfo (item) {
      const chain = await this.getWebhookRecordDetail({ recordid: item.recordid })
      chain.onSuccess(raw => {
        this.recordInfo = raw
        this.item = item
        this.$refs.sendRcordInfo.changeVisible(true)
      })
        .fetch()
    },
    toInquryInfo (item) {
      this.$router.push({
        // path: `/project/${this.pid}/inquery/detail/${inquiryid}`,
        name: item.inquirystatus === 1 ? 'InqueryPassDetail' : 'InqueryDetail',
        params: {
          pid: this.pid,
          inquiryId: item.inquiryid
        },
        query: {
          from: 'webhook',
          hookid: this.hookid
        }
      })
    },
    expandAllHandler (columns, record) {
      columns.forEach(item => {
        if (item.key === 'status') {
          const obj = this.filtersparams[item.key]
          item.customHeaderCell = (record) => {
            return {
              attrs: {
                id: item.key,
                class: `ant-table-column-has-actions ant-table-column-has-filters ${obj ? 'filter-th-selected' : ''}`
              }
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.sendrecord-select::v-deep {
  .crumb-title {
    padding: 0 0 24px;
    .second-tit {
      display: none;
    }
  }
  .iconicon-test15 {
    color: #d8d8d8;
    font-size: 12px;
  }
  .ant-dropdown-link:hover {
    .iconicon-test15 {
    color: #5077aa;
  }
  }
}
  .webhook-table-list::v-deep {
    margin-top: 24px;
    .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters .anticon-filter.ant-table-filter-open, .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters .ant-table-filter-icon.ant-table-filter-open,
    .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .anticon-filter:hover, .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .ant-table-filter-icon:hover
    {
      color: #5077aa;
    }
    .test-event-tit {
      margin-left: 6px;
    }
    .send-btn {
      margin-left: 10px;
    }
    .custom-filter-dropdown {
      margin: 13px 10px 10px 40px;
    }
    .webhook-item-address {
      width: 350px;
    }
    .send-error {
      color: #F6A953 !important;
    }
    .drop-down-box {
    width: 80px;
    background: #fff;
    border-radius: 4px;
    line-height: 30px;
    position: relative;
    z-index: 6;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
    a{
      display: block;
      color:#333;
      padding: 0 10px;
      text-align: center;
    }
    a:hover {
      background: #f4f7f9;
    }
  }
  }
</style>
<style lang="scss">
  .send-error-popover {
    max-width: 350px;
  }
</style>
